import { render, staticRenderFns } from "./left-rail.vue?vue&type=template&id=400065db&"
import script from "./left-rail.vue?vue&type=script&lang=js&"
export * from "./left-rail.vue?vue&type=script&lang=js&"
import style0 from "./left-rail.vue?vue&type=style&index=0&id=400065db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports